<template>
    <div style="width: 800px">
        <div>
            <el-checkbox-group v-model="$parentInfo.dialog_distributionSecondHeadTeacher.first_connect_second_headTeachers">
                <el-table
                        :data="$parentInfo.dialog_distributionSecondHeadTeacher.headTeachers"
                        border
                        height="500"
                        style="width: 100%">
                    <el-table-column prop="name" label="班主任\副班主任" width="180">
                    </el-table-column>
                    <el-table-column v-for="(item, index) in $parentInfo.dialog_distributionSecondHeadTeacher.headTeachers[0].connects" :key="index">
                        <template slot="header" slot-scope="scope">
                            {{item.secondHeadTeacher_name}}
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox :disabled="scope.row.connects[index].disabled" :label="scope.row.connects[index].id" >{{scope.row.connects[index].name}}</el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-checkbox-group>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateTeacher"
                       :loading="$parentInfo.dialog_distributionSecondHeadTeacher.button_loading">修 改
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_DistributionSecondHeadTeacher",
        data () {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleShow(){
                this.$wApi.send(this.$parentInfo.path, 'get_first_connect_second_headTeacher');
            },
            handleUpdateTeacher(){
                this.$parentInfo.dialog_distributionSecondHeadTeacher.button_loading=true
                this.$wApi.send(this.$parentInfo.path, 'update_first_connect_second_headTeacher',{
                    'first_connect_second_headTeachers':this.$parentInfo.dialog_distributionSecondHeadTeacher.first_connect_second_headTeachers,
                });
            }
        }
    }
</script>

<style scoped>

</style>